export type MobileUploadPayload = {
  projectCode: string
  categoryId?: number | null
  productId?: number | null
}

function normalizeBase64(input: string) {
  return String(input || '')
    .trim()
    .replace(/-/g, '+')
    .replace(/_/g, '/')
}

function toUrlSafeBase64(input: string) {
  return input.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '')
}

export function encodeMobileUploadPayload(payload: MobileUploadPayload): string {
  const categoryId = Number(payload.categoryId || 0)

  const json = JSON.stringify({
    projectCode: String(payload.projectCode || '').trim(),
    ...(categoryId > 0 ? { categoryId } : {}),
    ...(payload.productId ? { productId: Number(payload.productId) } : {}),
  })

  return toUrlSafeBase64(btoa(unescape(encodeURIComponent(json))))
}

export function decodeMobileUploadPayload(raw: string): MobileUploadPayload | null {
  const normalized = normalizeBase64(raw)
  if (!normalized) return null

  const padded = normalized + '='.repeat((4 - (normalized.length % 4 || 4)) % 4)

  try {
    const json = decodeURIComponent(escape(atob(padded)))

    const parsed = JSON.parse(json)
    const projectCode = String(parsed?.projectCode || '').trim()
    const categoryId = Number(parsed?.categoryId || 0)
    const productIdRaw = Number(parsed?.productId || 0)

    if (!projectCode) return null

    return {
      projectCode,
      ...(categoryId > 0 ? { categoryId } : {}),
      ...(productIdRaw > 0 ? { productId: productIdRaw } : {}),
    }
  } catch {
    return null
  }
}
